import http from '@/communication/AuthConnection'

export default async ({ commit }, payload) => {
  try {
    const request = await http.patch('/v1/board/task/wait-new-date', payload)
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/board/set-wait-new-date/index.js